// Create Provider to pass down qdt instance
import { QdtContext } from "../contexts"
import React from "react";

import QdtComponents from "qdt-components";

export const QdtProvider = ({ children }) => {
  // qlik connectivity
  const options = {
    config: {
      //host: "sense-sandbox.axisgroup.com",
      host: 'qlikqap.c40.com',
      // host: "qlikqap.c40.com",
      secure: true,
      port: 443,
      prefix: "anon",
      appId: "7b4d69d6-750e-4889-84be-aa2120502d8e" //on QAP
    },
    connections: {
      vizApi: true,
      engineApi: true
    }
  };

  // create qdtComponents instance
  const qdtComponents = new QdtComponents(options.config, options.connections);

  if (qdtComponents === null) {
    return "Loading..."
  } else {
    return (
      <QdtContext.Provider value={qdtComponents}>
        {children}
      </QdtContext.Provider>
    );
  }
};
